import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ArticlePage from "../pages/article/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/en/",
    element: <Home />,
  },
  {
    path: "/fr/",
    element: <Home />,
  },
  {
    path: "/da/",
    element: <Home />,
  },
  {
    path: "/de/",
    element: <Home />,
  },
  {
    path: "/articles/:slug/",
    element: <ArticlePage />,
  },
  {
    path: "/en/articles/:slug/",
    element: <ArticlePage />,
  },
  {
    path: "/fr/articles/:slug/",
    element: <ArticlePage />,
  },
  {
    path: "/da/articles/:slug/",
    element: <ArticlePage />,
  },
  {
    path: "/de/articles/:slug/",
    element: <ArticlePage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;